import { useState } from "react";
import TabBar from "components/shared/TabBar";
import CloseModalButton from "components/ui/CloseModalButton";
import Button from "hardcover-ui/components/Button";
import TextLink from "hardcover-ui/components/TextLink";
import JoinForm from "components/join/JoinForm";
import LoginForm from "components/join/LoginForm";

const tabs = [
  { name: "Login", href: "#" },
  { name: "Join", href: "#" },
];

const JoinOrLoginForm = ({
  onClose,
  tab,
}: {
  onClose?: () => void;
  tab: string;
}) => {
  const [complete, setComplete] = useState(false);
  const [currentTab, setActualTab] = useState(tab);

  return (
    <div>
      <div className="relative flex justify-between">
        {!complete && (
          <TabBar
            tabs={tabs}
            activeTab={currentTab}
            onTabChange={setActualTab}
          />
        )}
        {onClose && (
          <CloseModalButton
            onClick={() => onClose()}
            className="absolute top-0 right-0"
          />
        )}
      </div>

      <div className="mt-4">
        {currentTab === "Join" ? (
          <JoinForm complete={complete} onComplete={setComplete} />
        ) : (
          <LoginForm complete={complete} onComplete={setComplete} />
        )}
      </div>

      {!complete && (
        <div className="text-center mt-8">
          {currentTab === "Join" ? (
            <p>
              Already a member?{" "}
              <Button
                variant="link"
                className="underline"
                onClick={() => setActualTab("Login")}
              >
                Sign in
              </Button>
            </p>
          ) : (
            <p>
              <Button variant="link" onClick={() => setActualTab("Join")}>
                Sign up
              </Button>{" "}
              or{" "}
              <TextLink href="/users/password/new">Forgot Password?</TextLink>
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default JoinOrLoginForm;
